import { render, staticRenderFns } from "./HealthHistoryV2.vue?vue&type=template&id=f68a7112&scoped=true&v-if=canFillForm&"
import script from "./HealthHistoryV2.vue?vue&type=script&lang=js&"
export * from "./HealthHistoryV2.vue?vue&type=script&lang=js&"
import style0 from "./HealthHistory.scss?vue&type=style&index=0&id=f68a7112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68a7112",
  null
  
)

export default component.exports